export default __webpack_public_path__ + "static/media/DizLog_Logo_Horizontal_01.0974d535.svg";